import { base } from "@theme-ui/presets"

export default {
  ...base,
  colors: {
    ...base.colors,
    text: `#222`,
    primary: `#2942a1`,
  },
  fontSizes: [12, 16, 18, 22, 26, 34, 48, 64],
  sizes: {
    container: 960,
  },
}
